import {AdminApi} from "./AdminApi";
import {Brand} from "@unleashed/models/Brand";

const PermissionsApi = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyPermissions: builder.query<Brand[], void>({
      query: () => {
        return {
          url: "permissions/my",
          method: "GET"
        };
      },
      keepUnusedDataFor: 86400,
      providesTags: [{type: "Permissions", id: "MY"}]
    }),
  }),
});

export const {
  useGetMyPermissionsQuery,
} = PermissionsApi;
